import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow\">\n    <title>icon/10pt/箭头</title>\n    <g id=\"icon-arrow_icon/10pt/箭头\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <polyline id=\"icon-arrow_路径备份-2\" stroke=\"currentColor\" stroke-width=\"10\" transform=\"translate(38.680195, 47.819805) rotate(-315.000000) translate(-38.680195, -47.819805) \" points=\"16.1801948 25.3198052 52.4520305 33.0860287 61.1801948 70.3198052\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow.svg
// module id = nCIC
// module chunks = 2